export default __webpack_public_path__ + "static/media/cloud-left.93091179.svg";